export const USERS_MANAGEMENT_STRATEGY_INFO_KEY = "usersManagementStrategyInfo";
